import {
    COMMISSIONS_DETAILED_VIEW, COMMISSIONS_NONE_VIEW,
    COMMISSIONS_SUMMARY_VIEW,
} from '../Constants/Constants';

export const getReferralsViewType = (affiliateDetails: any) => {
    let referralsViewType;
    switch (affiliateDetails?.affiliate?.commission_view) {
        case COMMISSIONS_SUMMARY_VIEW:
            referralsViewType = COMMISSIONS_SUMMARY_VIEW;
            break;
        case COMMISSIONS_DETAILED_VIEW:
            referralsViewType = COMMISSIONS_DETAILED_VIEW;
            break;
        default:
            referralsViewType = COMMISSIONS_SUMMARY_VIEW;
    }
    return referralsViewType;
};

export const getReferralsViewTypeFromCommissionsViewType = (commissionsViewType: string) => {
    let referralsViewType: string = COMMISSIONS_SUMMARY_VIEW;
    referralsViewType = commissionsViewType === COMMISSIONS_NONE_VIEW ? referralsViewType : commissionsViewType;

    return referralsViewType
}